export default __webpack_public_path__ + "static/media/view-icon.6ec2e7b6.svg";